import { ColGroupDef, IHeaderGroupParams } from "@ag-grid-community/core";
import { IconButton } from "@chakra-ui/react";
import React from "react";
import { isColGroupDefWithChildren } from "shared/components/table/maybern/MaybernTableUtils";
import { ColumnGroupCloseIcon } from "shared/icons/ColumnGroupCloseIcon";
import { ColumnGroupOpenIcon } from "shared/icons/ColumnGroupOpenIcon";

export const MaybernTableHeaderGroupExpandButton: React.FC<
  IHeaderGroupParams
> = (props) => {
  const isExpandable = props.columnGroup.isExpandable();
  const isExpanded = props.columnGroup.isExpanded();
  return isExpandable ? (
    <IconButton
      w="24px"
      h="24px"
      variant="ghost"
      aria-label="Expand"
      icon={isExpanded ? <ColumnGroupCloseIcon /> : <ColumnGroupOpenIcon />}
      onClick={() => {
        props.api.setColumnGroupOpened(
          props.columnGroup.getProvidedColumnGroup(),
          !isExpanded,
        );
        const getColumnIds = (columnGroup: ColGroupDef | null): string[] =>
          columnGroup?.children.flatMap((c) =>
            isColGroupDefWithChildren(c) ? getColumnIds(c) : [c.colId!],
          ) ?? [];
        const columnIds = getColumnIds(props.columnGroup.getColGroupDef());
        if (columnIds.length) {
          props.api.autoSizeColumns(columnIds);
        }
        // recompute class names
        props.api.refreshHeader();
        props.api.redrawRows();
      }}
    />
  ) : null;
};
